import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const pageContainer = document.getElementById('root');
    pageContainer?.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
